import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Add slideshow images with home, home2, home3, home4
  const slides = [
    `${process.env.PUBLIC_URL}/home.jpg`,
    `${process.env.PUBLIC_URL}/home2.jpg`,
    `${process.env.PUBLIC_URL}/home3.jpg`,
    `${process.env.PUBLIC_URL}/home4.jpg`,
  ];
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    setIsVisible(true);
  }, []);
  // Add auto-advance for slideshow (2s crossfade handled in CSS)
  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex((i) => (i + 1) % slides.length);
    }, 2000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="hero"
    >
      {/* Slideshow background layer */}
      <div className="hero-slides">
        {slides.map((src, i) => (
          <div
            key={i}
            className={`hero-slide ${i === slideIndex ? 'active' : ''}`}
            style={{
              backgroundImage: `linear-gradient(135deg, rgba(248, 250, 252, 0.5) 0%, rgba(226, 232, 240, 0.5) 100%), url(${src})`,
            }}
          />
        ))}
      </div>

      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className={`hero-text ${isVisible ? 'animate-in' : ''}`}>
            <h1 className="hero-title">
              <span className="title-line">Premium</span>
              <span className="title-line highlight">Surgical Instruments</span>
              <span className="title-line">for Medical Excellence</span>
            </h1>
            
            <p className="hero-description">
              Discover our comprehensive range of high-quality surgical instruments 
              designed for precision, reliability, and superior performance in medical procedures.
            </p>
            
            <div className="hero-actions">
              <button 
                className="btn btn-primary btn-large"
                onClick={scrollToProducts}
              >
                Explore Products
              </button>
              <a className="btn btn-outline btn-large" href="/#contact">
                Get Consultation
              </a>
            </div>
            
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Products</span>
              </div>
              <div className="stat">
                <span className="stat-number">25+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span className="stat-number">1000+</span>
                <span className="stat-label">Satisfied Clients</span>
              </div>
            </div>
          </div>
          
          <div className={`hero-visual ${isVisible ? 'animate-in' : ''}`}>
            <div className="hero-image-container">
              <div className="floating-card card-1">
                <div className="card-icon">🏥</div>
                <div className="card-text">
                  <h4>Hospital Grade</h4>
                  <p>Premium Quality</p>
                </div>
              </div>
              
              <div className="floating-card card-2">
                <div className="card-icon">⚕️</div>
                <div className="card-text">
                  <h4>Medical Certified</h4>
                  <p>ISO Standards</p>
                </div>
              </div>
              
              <div className="floating-card card-3">
                <div className="card-icon">🔬</div>
                <div className="card-text">
                  <h4>Precision Tools</h4>
                  <p>Advanced Technology</p>
                </div>
              </div>
              
              <div className="hero-main-visual">
                <div className="visual-circle">
                  <div className="inner-circle">
                    <img src="/too.jpg" alt="Purelife impex" className="inner-circle-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;